var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDownload01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1_",
    d: "M3.1,35c-1.4,0-2.6-1.2-2.6-2.6l0,0v-3.5c0-1.4,1.2-2.6,2.6-2.6l0,0h1.8c0.8,0,1.5,0.7,1.5,1.5l0,0 c0,0.8,0.7,1.5,1.5,1.5h20.4c0.8,0,1.5-0.7,1.5-1.5s0.7-1.5,1.5-1.5h1.8c1.4,0,2.6,1.2,2.6,2.6v3.5c0,1.4-1.2,2.6-2.6,2.6H3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2_1_",
    d: "M6.8,15.8c-0.2-0.5-0.3-1-0.3-1.5l0,0c0-1.7,1.4-3.1,3.1-3.2c0.6,0,1.3,0.2,1.8,0.5l3.8,2.6L14,5.8 c-0.1-0.7-0.1-1.4,0.1-2.1c0.8-2.1,3.1-3.3,5.3-2.5c1.2,0.4,2.1,1.3,2.5,2.5c0.2,0.7,0.3,1.4,0.1,2.1l-1.1,8.5l3.8-2.6 c1.4-1,3.4-0.6,4.4,0.8c0.4,0.5,0.5,1.1,0.5,1.8l0,0c0,1-0.5,2-1.3,2.7l-9.2,7.4c-0.6,0.5-1.5,0.5-2.1,0L7.7,17 C7.3,16.7,7,16.3,6.8,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownload01);
export default __webpack_public_path__ + "static/media/ico-download-01.dcc9377a5e0380762324592ad5ee64fa.svg";
export { ForwardRef as ReactComponent };